import React from 'react';
import {NextPage} from 'next';
import { createGetServerSideProps, StaticPageProps } from "evcharging/app";
import {
  AllSetSection,
  AreaInformationSection,
  ConfirmSelectionSection,
  DoubleCardsSection,
  HeaderLedSection,
  HowItWorksSection,
  LedInformationAppSection,
  OneLastStepSection,
  PlaceOrderSection,
  SelectReplacementsSection,
  StartProjectSection,
  WhyNeedEmailSection,
  WhySwitchToLedSection,
} from 'containers/common/sections/led';
import {Page} from 'containers/common/sections/layout';
import {I18nPage} from "i18n/types/pages.enum";

const LightningRetrofitPage: NextPage<StaticPageProps> = ({page}) => {
  return (
    <Page title={page.meta_title} description={page.meta_description} locales={page.locales} showTransparentBg>
      <HeaderLedSection />
      <WhySwitchToLedSection />
      <HowItWorksSection />
      <DoubleCardsSection />
      <StartProjectSection />
      <WhyNeedEmailSection />
      <AreaInformationSection />
      <SelectReplacementsSection />
      <ConfirmSelectionSection />
      <PlaceOrderSection />
      <AllSetSection />
      <OneLastStepSection />
      <LedInformationAppSection />
    </Page>
  );
};

export const getServerSideProps = createGetServerSideProps(undefined, undefined, [I18nPage.LightingRetrofitLanding]);

export default LightningRetrofitPage;
